<template>
  <div
    id="adn-layout-horizontal-list"
    :class="{ 'adn-layout-horizontal-list--mobile-screen-edge-overflow': mobileContainerOverflow }"
    data-test-main-div
  >
    <ul class="adn-layout-horizontal-list__products-list">
      <li v-for="(item, index) in items" :key="'item' + index" class="adn-layout-horizontal-list__product">
        <!-- @slot Use this slot to decide how to display each element -->
        <slot :item="item" :index="index"></slot>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'AdnLayoutHorizontalList',
  props: {
    items: {
      type: Array,
    },
    mobileContainerOverflow: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.adn-layout-horizontal-list--mobile-screen-edge-overflow {
  .adn-layout-horizontal-list__product {
    &:not(:last-child) {
      margin-right: var(--spacing-2);
    }
  }
}

.adn-layout-horizontal-list__products-list {
  display: flex;
  flex-flow: row nowrap;
  overflow-x: auto;
  margin: 0;
  list-style-type: none;
}
</style>
